export const SELECT_SCHEMA_COLLECTIONS = {
  BUSINESS_PARTNER: 'mst-business-partner',
  SUB_ROUTE: 'mst-sub-route',
  MATERIAL: 'mst-material',
  DOCUMENT_CLASS: 'mst-document-class',
  EMISSION_POINT: 'mst-emission-point',
  DOCUMENT_RANGE: 'mst-document-range',
  COMPANY: 'mst-company',
  MATERIAL_GROUP: 'mst-material-group',
  MATERIAL_LIST: 'mst-material-list',
  MATERIAL_LIST_COMPONENT: 'mst-material-list-component',
  ADDRESS_TYPE: 'mst-address-type',
  BUSINESS_PARTNER_CONTACT_FUNCTION: 'mst-business-partner-contact-function',
  BUSINESS_PARTNER_FUNCTION: 'mst-business-partner-function',
  BUSINESS_PARTNER_GROUP: 'mst-business-partner-group',
  BUSINESS_PARTNER_SCHEDULE: 'mst-business-partner-schedule',
  BUSINESS_PARTNER_SUB_GROUP: 'mst-business-partner-sub-group',
  BUSINESS_PARTNER_TYPE: 'mst-business-partner-type',
  ROUTE: 'mst-route',
  APPOINTMENT: 'mst-appointment',
  ROUTE_AREA: 'mst-route-area',
  ROUTE_GROUP: 'mst-route-group',
  ROUTING_ITINERARY: 'mst-routing-itinerary',
  SUB_ROUTE_FUNCTION: 'mst-sub-route-function',
  MATERIAL_BRAND: 'mst-material-brand',
  DOCUMENT_DETAIL_CLASS: 'mst-document-detail-class',
  DOCUMENT_DETAIL_TYPE: 'mst-document-detail-type',
  DOCUMENT_TYPE: 'mst-document-type',
  CHANNEL: 'cnf-channel',
  COMPANY_HOLIDAY: 'cnf-company-holiday',
  DEFAULT_KEYS: 'sys-default-keys',
  DISTRIBUTION_CHAIN: 'cnf-distribution-chain',
  DIVISION: 'cnf-division',
  OFFICE_GROUP: 'cnf-office-group',
  PLANTS: 'cnf-plants',
  SALES_OFFICE: 'cnf-sales-office',
  SALES_ORGANIZATION: 'cnf-sales-organization',
  SHORTCUTS: 'cnf-shortcuts',
  SOCIAL_MEDIA_TYPE: 'mst-social-media-type',
  TENANT: 'cnf-tenant',
  WAREHOUSE: 'cnf-warehouse',
  BANKS: 'mst-banks',
  PAYMENT_TYPES: 'mst-payment-types',
  PAYMENT_METHODS: 'mst-payment-methods',
  PRICE_LIST: 'mst-price-list',
  CLASSIFICATION: 'mst-classification',
  CURRENCY: 'mst-currency',
  EXPEDITION_CONDITION: 'mst-expedition-condition',
  EXPENSE_REASONS: 'mst-expense-reasons',
  USERS: 'masters_users',
  USERS_LOGIN: 'users_login',
  MOTIVE_BLOCK: 'mst-motive-block',
  PAYMENT_CONDITION: 'mst-payment-condition',
  REASON_REJECTION: 'mst-reason-rejection',
  REASON_REJECTION_TYPE: 'mst-reason-rejection-type',
  REASON_VISIT: 'mst-reason-visit',
  REQUIREMENT: 'mst-requirement',
  UNIT_MEASUREMENT_GROUP: 'mst-unit-measurement-group',
  UNIT_MEASUREMENT: 'mst-unit-measurement',
  VEHICLE: 'mst-vehicle',
  VEHICLE_TYPE: 'mst-vehicle-type',
  ASSETS: 'mst-assets',
  ASSET_CONTROL: 'mst-asset-control',
  ASSET_GROUP: 'mst-asset-groups',
  VISIT: 'prc-visit',
  VISIT_CHECK: 'prc-visit-check',
  TRIP: 'prc-trip',
  BAD_CONDITION: 'mst-bad-condition',
  PRICE_LIST_SEQUENCE: 'mst-price-list-sequence',
  TEMPORARY_PASSWORD: 'temporary_passwords',
  LOCATION_SIX: 'mst-location-six',
  LOCATION_FIVE: 'mst-location-five',
  LOCATION_FOUR: 'mst-location-four',
  LOCATION_THREE: 'mst-location-three',
  LOCATION_TWO: 'mst-location-two',
  LOCATION_ONE: 'mst-location-one',
  NOTIFICATION_TEMPLATE: 'cnf-notification-template',
  NOTIFICATION_MEMBER: 'cnf-notification-member',
  NOTIFICATION_GROUP: 'cnf-notification-group',
  NOTIFICATION: 'cnf-notification',
  PHONE_TYPE: 'mst-phone-type',
  RETURN_TYPE: 'mst-return-type',
  CREDIT_APPLICATION: 'prc-credit-applications',
  ORDER: 'prc-order',
  MENU_ITEM: 'acl-menu-item',
  MATERIAL_SALES_HIERARCY: 'mst-material-sales-hierarchy',
  CHANGE_CONDITION: 'mst-change-condition',
  IDENTITY_DOCUMENT_TYPE: 'mst-identity-document-type',
} as const;

export type AuditLogCollection = (typeof SELECT_SCHEMA_COLLECTIONS)[keyof typeof SELECT_SCHEMA_COLLECTIONS];
